import SeoHelmet from "@/components/SeoHelmet";

export default function Press() {
  return (
    <div className="container max-w-3xl mx-auto px-4 py-12">
      <SeoHelmet
        title="Press & Badges"
        description="Press resources and badges for Alvaru - AI CV tailoring tool."
        canonical="https://www.alvaru.com/press"
      />

      <h1 className="text-3xl font-bold mb-6">Press & Badges</h1>

      <p className="text-slate-600 dark:text-slate-400 mb-8">
        Alvaru is an AI-powered CV tailoring tool that helps job seekers get more interviews.
        Our Chrome extension rewrites your resume for each job description and auto-applies
        on LinkedIn, Indeed, and other major job boards.
      </p>
      <p className="text-slate-600 dark:text-slate-400 mb-8">
        For media inquiries, please contact us at <a href="mailto:press@alvaru.com" className="text-cyan-600 dark:text-cyan-400">press@alvaru.com</a>.
      </p>

      <div className="space-y-8">
        <section>
          <h2 className="text-xl font-semibold mb-3">Featured on</h2>
          <div className="flex flex-wrap gap-4">
            <a href="https://dang.ai" target="_blank" rel="dofollow noopener" className="inline-flex items-center gap-2 border border-purple-600 bg-black text-white font-bold text-sm rounded-lg px-3 py-2 no-underline">
              Featured on Dang.ai
            </a>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">Badge Embed Code</h2>
          <pre className="bg-gray-100 p-4 rounded-lg overflow-x-auto text-sm">
            <code>{`<a href="https://dang.ai" target="_blank" rel="dofollow noopener" style="display:inline-flex;align-items:center;gap:8px;border:1px solid #6a23e7;background:#050505;color:#ffffff;font:700 14px/1.2 Arial,sans-serif;text-decoration:none;border-radius:8px;padding:10px 12px;">Featured on Dang.ai</a>`}</code>
          </pre>
        </section>
      </div>
    </div>
  );
}
